<template>
  <Menu as="div" class="relative z-10 inline-block text-left">
    <div>
      <MenuButton
        class="flex w-full items-center justify-center space-x-2 rounded-md text-sm font-medium text-white capitalize-first"
        :class="cButtonClasses"
      >
        <FontAwesomeIcon
          v-if="icon !== null"
          class="flex-shrink-0"
          :icon="['fal', icon]"
        />
        <span v-if="with_label" class="capitalize-first">
          {{ cCurentStatut && cCurentStatut[label] }}
        </span>
        <FontAwesomeIcon
          v-if="displayChevron"
          :icon="['fal', 'chevron-down']"
        />
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
      >
        <div class="px-1 py-1">
          <MenuItem v-for="item in options" :key="item" v-slot="{ active }">
            <button
              :class="[
                active ? 'bg-gray-500 text-white' : 'text-gray-900',
                'group flex w-full items-center space-x-3 rounded-md px-2 py-2 text-sm',
                cCurentStatut[trackBy] === item[trackBy] ? 'bg-gray-200' : ''
              ]"
              @click="mSelect(item[trackBy])"
            >
              <span
                class="h-3 w-3 flex-shrink-0 rounded-full"
                :class="'bg-theme-' + item[color]"
              ></span>

              <span class="flex-1 text-left capitalize-first">
                {{ item[label] }}
              </span>
              <font-awesome-icon
                v-if="cCurentStatut[trackBy] === item[trackBy]"
                class="flex-shrink-0"
                :icon="['fal', 'check']"
              />
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DropdownStatus',
  components: {
    FontAwesomeIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    current: {
      required: true
    },
    displayChevron: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      required: false,
      default: 'name'
    },
    with_label: {
      required: false,
      default: true
    },
    icon: {
      required: false,
      default: null
    },
    trackBy: {
      required: false,
      default: 'id'
    },
    color: {
      required: false,
      default: 'color'
    },
    btnStyle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['select'],
  computed: {
    cCurentStatut() {
      return (
        this.options && this.options.find((item) => item.id === this.current)
      )
    },
    cButtonColor() {
      return this.cCurentStatut && 'bg-theme-' + this.cCurentStatut[this.color]
    },
    cButtonStyle() {
      return this.btnStyle ? 'btn' : ' px-2 py-1 '
    },
    cButtonClasses() {
      return [this.cButtonColor, this.cButtonStyle]
    }
  },
  methods: {
    mSelect(value) {
      this.$emit('select', {
        [this.trackBy]: value
      })
    }
  }
}
</script>
